// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__dg3lz","subheader":"ReorderModal_subheader__3arYV","listWrap":"ReorderModal_listWrap__2b8Hh"};